import {TrackWebboardRequest} from "./model/api";
import { Logger } from "../util/Logger";
import { Common } from "./Common";


const sourceFileName = "WebboardController.ts";

export class WebboardController{
    public static async _trackRequest(request:TrackWebboardRequest, token:string){
       
		let requestHeaders: any = {
			"Content-Type": "application/json",
			"Authorization":"Bearer "+ token,
		};

		const requestURL = Common.getNRActionUrl("api/OOEVV/TrackWebboardRequests");
		
		const resBody = await fetch(requestURL,
			{
				method: "POST",
                body:JSON.stringify(request),
				headers: requestHeaders
			},
		);
		
        if (!resBody.ok) {
			throw new Error(`Error while sending GET request to NR API endpoint.`
				+ ` HTTP status code was ${resBody.status}. HTTP body of request: ${JSON.stringify(request)}.`);
		}
    }
}